<template>
    <div class="content">
        <div class="top-box">
            <div class="btn btn-home" @click="toHome">数据概览</div>
            <div class="btn btn-device" @click="toDevice">设备管理</div>
            <div class="btn btn-patient" @click="toUser">患者管理</div>
            <div class="btn-active btn-data" @click="toData">手表数据</div>
            <div class="btn-admin"></div>
            <img class="btn-icon" src="@/assets/home/04icon.png">
            <div class="user-name">{{ loginName }}</div>
            <div class="time-box">{{ time }}</div>
        </div>
        <div class="main">
            <div class="tab-box">
                <div class="tab" :class="{'tab-active': currentTab === 0}" @click="changeTab(0)">账号信息</div>
                <div class="tab-split"></div>
                <div class="tab" :class="{'tab-active': currentTab === 1}" @click="changeTab(1)">子账号管理</div>
                <div class="tab-split"></div>
                <div class="tab" :class="{'tab-active': currentTab === 2}" @click="changeTab(2)">角色管理</div>
            </div>
            <div class="tab-content" v-if="currentTab === 0">
                <div class="admin-info">
                    <el-upload
                        class="avatar-uploader"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="admin-info-right">
                        <el-form label-position="left" size="mini">
                            <el-form-item label="登录名" label-width="90px">
                                <el-input
                                    type="text"
                                    placeholder="请输入"
                                    v-model="loginName"
                                    disabled
                                >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="登录密码" label-width="90px">
                                <el-input
                                    show-password
                                    placeholder="请输入"
                                    v-model="admin.pwd">
                                </el-input>
                            </el-form-item>
                        </el-form>
                        <el-button type="primary" size="mini">确认修改</el-button>
                    </div>
                </div>
            </div>
            <div class="tab-content" v-if="currentTab === 1">
                <div class="sub-account">
                    <div class="btn-box">
                        <el-button type="primary" @click="addAdmin" size="mini" icon="el-icon-plus">新增
                        </el-button>
                    </div>
                    <el-table
                        :data="tableData"
                        stripe
                        border
                        style="width: 100%"
                    >
                        <el-table-column
                            prop="id"
                            label="ID"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="userName"
                            label="登录名"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="role"
                            label="角色"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="ctime"
                            label="创建时间"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="versionDec"
                            label="操作"
                            width="250">
                            <template slot-scope="scope">
                                <div>
                                    <div class="table-btn table-btn0" @click="updateAdmin(scope.row)">编辑</div>
                                    <div class="table-btn table-btn1" @click="resetPwd(scope.row)">重置密码</div>
                                    <div class="table-btn table-btn2" @click="openDeleteAdmin(scope.row)">删除</div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="tab-content" v-if="currentTab === 2">
                <div class="sub-account">
                    <div class="btn-box">
                        <el-button type="primary" @click="addVisible = true" size="mini" icon="el-icon-plus">新增
                        </el-button>
                    </div>
                    <el-table
                        :data="roleData"
                        stripe
                        border
                        style="width: 100%"
                    >
                        <el-table-column
                            prop="roleId"
                            label="ID"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="roleName"
                            label="角色名"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="addTime"
                            label="创建时间"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="versionDec"
                            label="操作"
                            width="250">
                            <template slot-scope="scope">
                                <div>
                                    <div class="table-btn table-btn0" @click="updateRole(scope.row)">编辑</div>
                                    <div class="table-btn table-btn2" @click="openDeleteRole(scope.row)">删除</div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <el-dialog
            title="编辑用户"
            :visible.sync="editAdminVisible"
            width="600px"
            :fullscreen="false"
            :close-on-click-modal="false"
            :before-close="handleCloseAdmin">
            <el-form :rules="rulesAdmin" :model="manageUser" label-width="80px" ref="addForm">
                <el-form-item label="登录名" prop="userName">
                    <el-input v-model="manageUser.userName" :disabled="manageUser.id"></el-input>
                </el-form-item>
                <el-form-item v-if="isAdd" key="pwd" label="密码" prop="pwd">
                    <el-input v-model="manageUser.pwd"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="role">
                    <el-select @change="changeRole" v-model="manageUser.roleId" placeholder="请选择角色">
                        <el-option v-for="item in roleData" :key="item.roleId" :label="item.roleName"
                                   :value="item.roleId"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitUpdate('addForm')">提 交</el-button>
                    <el-button type="primary" @click="handleCloseAdmin">关 闭</el-button>
                </span>
        </el-dialog>
        <el-dialog
            title="重置密码"
            :visible.sync="resetAdminVisible"
            width="600px"
            :fullscreen="false"
            :close-on-click-modal="false"
            :before-close="handleCloseAdmin">
            <el-form :rules="resetRules" :model="manageUser" label-width="80px" ref="resetPwd">
                <el-form-item label="密码" key="resetPwd" prop="resetPwd">
                    <el-input v-model="manageUser.resetPwd"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitResetPwd('resetPwd')">提 交</el-button>
                    <el-button type="primary" @click="handleCloseAdmin">关 闭</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: 'index',
    data() {
        var checkUserName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入登录名'));
            } else if (value == this.orgName) {
                callback();
            } else {
                // 调用后端api
                this.$api.admin.checkUserNameApi({userName: value}).then(Response => {
                    if (Response.data == 0) {
                        callback();
                    } else {
                        callback(new Error('该登录名已存在'));
                    }
                })
            }
        };
        return {
            loginName:localStorage.getItem("phone"),
            time: '',
            currentTab: 0,
            imageUrl: '',
            admin: {
                loginName: '',
                pwd: '',
                phone: ''
            },
            addVisible: false,
            tableData: [],
            roleData: [],
            editAdminVisible: false,
            rulesAdmin: {
                userName: [
                    {required: true, message: '请输入登录名', trigger: 'blur'},
                    {validator: checkUserName, trigger: 'blur'}
                ],
                phone: [
                    {required: false, message: '请输入手机号', trigger: 'blur'}
                ],
                role: [
                    {required: true, message: '请选择角色', trigger: 'blur'}
                ],
                pwd: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
                ]
            },
            manageUser: {},
            isAdd: false,
            orgName: '',
            resetRules: {
                resetPwd: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
                ]
            },
            resetAdminVisible: false,
        }
    },
    mounted() {
        this.startTimer();
    },
    methods: {
        toHome() {
            this.$router.push({
                path: '/home',
            })
        },
        toDevice() {
            this.$router.push({
                name: 'device'
            })
        },
        toUser() {
            this.$router.push({
                name: 'user'
            })
        },
        toData() {
            this.$router.push({
                name: 'data'
            })
        },
        getTime() {
            let time = new Date();
            let year = time.getFullYear();
            let month = (time.getMonth() + 1).toString().padStart(2, '0');
            let day = time.getDate().toString().padStart(2, '0');
            let hour = time.getHours().toString().padStart(2, '0');
            let minute = time.getMinutes().toString().padStart(2, '0');
            let second = time.getSeconds().toString().padStart(2, '0');
            this.time = year + '/' + month + '/' + day + '\n' + hour + ':' + minute + ':' + second;
            this.latestTime = this.time
        },
        startTimer() {
            // 立即执行一次
            this.getTime();
            // 每秒执行一次
            setInterval(() => {
                this.getTime();
            }, 1000);
        },
        changeTab(index) {
            this.currentTab = index;
            if (index === 1) {
                this.getManagerList()
                this.getRoleList()
            } else if (index === 2) {
                this.getRoleList()
            }
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        getManagerList() {
            this.$api.admin.getManagerList({
                pageNum: 1,
                pageSize: 1000
            }).then(res => {
                this.tableData = res.data.items
            })

        },
        openDeleteAdmin(item) {
            this.$confirm('确定要删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteAdmin(item)
            })
        },
        deleteAdmin(item) {
            this.$api.admin.deleteAdmin({
                id: item.id,
                delUserName: item.userName
            }).then(res => {
                if (res.result == 1) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getManagerList()
                }
            })
        },
        getRoleList() {
            this.$api.admin.getRoleList().then(res => {
                this.roleData = res.data
            })
        },
        addAdmin() {
            this.isAdd = true
            this.orgName = ''
            this.editAdminVisible = true
        },
        updateAdmin(item) {
            this.isAdd = false
            this.manageUser = item;
            this.orgName = item.userName.slice(0);
            this.editAdminVisible = true
        },
        onSuccess() {
            this.handleCloseAdmin();
            this.$message({
                message: '成功',
                type: 'success'
            });
        },
        handleCloseAdmin() {
            this.editAdminVisible = false;
            this.resetAdminVisible = false;
            this.manageUser = {};
            this.resetForm('addForm');
            this.resetForm('resetPwd');
            this.getManagerList();
        },
        resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        submitUpdate(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.isAdd) {
                        this.$api.admin.addManage(this.manageUser).then(response => {
                            this.onSuccess()
                        })
                    } else {
                        this.$api.admin.updateManage(this.manageUser).then(response => {
                            this.onSuccess()
                        })
                    }
                } else {
                    return false;
                }
            });
        },
        resetPwd(item) {
            this.manageUser = item;
            this.resetAdminVisible = true
        },
        submitResetPwd(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$api.admin.resetPwd({
                        id: this.manageUser.id,
                        pwd: this.manageUser.resetPwd,
                        operUserName: this.manageUser.userName
                    }).then(response => {
                        this.onSuccess()
                    })
                } else {
                    return false;
                }
            });
        },
        changeRole(e) {
            console.log(e)
            let obj = {};
            //使用find()方法在下拉数据中根据value绑定的数据查找对象。
            obj = this.roleData.find(function (item) {
                return item.roleId === e;
            })
            this.manageUser.role = obj.roleName
        },
        openDeleteRole(item) {
            if (item.roleId == 1) {
                this.$message.error('不能删除超级管理员');
                return
            }
            this.$confirm('确定要删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRole(item)
            })
        },
        deleteRole(item) {
            this.$api.admin.deleteRole({
                roleId: item.roleId
            }).then(res => {
                if (res.result == 1) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getRoleList()
                }
            })
        },
    }
}
</script>

<style scoped>
.content {
    width: 1920px;
    height: 1080px;
    background-color: #0A192F;
    background-image: url("~@/assets/home/01bg.png");
    background-size: cover;
    box-sizing: border-box;
    overflow-x: hidden;
    font-size: 14px;
}

.main {
    width: 1813px;
    height: 907px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0px 0px 0px 0px;
    margin: 0 auto;
    font-size: 14px;
}

.tab-box {
    display: flex;
    color: #ffffff;
    padding-top: 20px;
    padding-left: 10px;
    align-items: center;
}

.tab {
    cursor: pointer;
    width: 100px;
    height: 24px;
    margin: 0 10px;
    text-align: center;
}

.tab-active {
    background: url("~@/assets/admin/01btn.png");
    background-size: cover;
}

.tab-split {
    width: 2px;
    height: 14px;
    background: #607C97;
}

.admin-info {
    display: flex;
    margin-left: 21px;
    margin-top: 40px;
}

/deep/ .el-upload {
    border: 1px dashed #0088FF;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
    border-radius: 50%;
}

/deep/ .el-input__inner {
    background-color: rgba(0, 111, 255, 0.1);
    color: #ffffff;
    border: 0.005208rem solid rgba(0, 136, 255, 0.6);
}

.admin-info-right {
    margin-left: 40px;
}

/deep/ i {
    font-size: 12px;
}

.sub-account {
    margin-top: 32px;
    margin-left: 32px;
}

.btn-box {
    margin-bottom: 32px;
}

/deep/ .el-table {
    height: 700px !important;
}

.table-btn0 {
    color: #0088FF;
}

.table-btn1 {
    color: #1CB9FF;
}

.table-btn2 {
    color: #FF3A62;
}

.table-btn {
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/admin/index.vue